import * as React from 'react';
import PageHeader from './Components/PageHeader/PageHeader';
import PageFooter from './Components/PageFooter/PageFooter';
import SignUp from './Components/PageBody/SignUpPage/SignUpPage';
import './App.scss';
import { glassboxErrorEvent } from './Components/Service/Glassbox';

function App() {
    window.addEventListener("error", (event) => {
        glassboxErrorEvent(event);
    });

    return (
        <div>
            <PageHeader />
            <main role="main" id="main-content">
                <SignUp />
            </main>
            <PageFooter />
        </div>
    );
}

export default App;